import { Helmet } from 'react-helmet-async'

export default function PageTitle ({ title }: { title: string }): JSX.Element {
  return (
    <Helmet>
      <title>Campaign 2024 Dashboard: {title}</title>
    </Helmet>
  )
}
